<template>
    <div>
        <!-- <div v-if="hasSearch" class="text-center">
            <input type="text" v-model="searchTerm" placeholder="Meklēt pēc nosaukuma..."
                   class="my-4 px-4 py-2 ds-input" @input="attemptSearch">
        </div> -->
        <div class="row text-center my-4">
            <div class="col-sm-1 font-weight-bold text-left">Izvēlēts</div>
            <div class="col-sm-3 font-weight-bold text-left">Vārds, Uzvārds</div>
            <div class="col-sm-4 font-weight-bold text-left">Veselības pārbaudes veids</div>
            <div class="col-sm-2 font-weight-bold text-left"></div>
            <div class="col-sm-2 font-weight-bold text-right">Tuvākās pārbaudes datums</div>

        </div>
        <UserOvpJobConditionListItem v-for="user in sortedUsers"
                            :key="user._id"
                            :user="user"/>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import * as ovpStoreTypes from '../../../vuex/modules/ovp/ovp.store-types';
    import * as companyStoreTypes from '../../../vuex/modules/company/company.store-types';
    import UserOvpJobConditionListItem from './UserOvpJobConditionListItem';

    export default {
        name: 'user-ovp-job-condition-list',
        components: {UserOvpJobConditionListItem},
        props: {
            hasSearch: {
                type: Boolean,
                default: false,
            }
        },
        data: () => ({
            searchTerm: '',
            searchTimeout: null,
        }),
        created() {
            // this.getOvpJobConditionList();
        },
        computed: {
            sortedUsers() {
                return [...this.currentCompany.users]
                    .filter(({workExperience}) => workExperience)
                    .filter(({ovpJobConditions}) => ovpJobConditions.length)
                    .sort((a, b) => {
                        // Sorting users by their latest ovp - FYI this needs to be cleaned up!!!
                        const aDate = a.ovpJobConditions[0].nextInspectionDate.split('.');
                        const bDate = b.ovpJobConditions[0].nextInspectionDate.split('.');
                        return new Date(aDate[2], aDate[1], aDate[0]) - new Date(bDate[2], bDate[1], bDate[0]);
                    });
            },
            ...mapGetters('ovp', {
                /** @type {boolean|*} */
                isLoading: ovpStoreTypes.GET_IS_LOADING,
                /** @type {OvpJobCondition[]|*} */
                ovpJobConditions: ovpStoreTypes.GET_OVP_JOB_CONDITIONS,
            }),
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
        },
        methods: {
             ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyOvpJobConditions: companyStoreTypes.SET_CURRENT_COMPANY_OVP_JOB_CONDITIONS,
            }),
            ...mapActions('ovp', {
                /** @type {function|*} */
                getOvpJobConditions: ovpStoreTypes.ACTION_GET_OVP_JOB_CONDITIONS,
            }),
            async getOvpJobConditionList(search = '') {
                const ovpJobConditions = await this.getOvpJobConditions({name: search, companyId: this.$route.params.companyId || this.currentCompany._id});

                if (this.currentCompany._id && ovpJobConditions) {
                    this.setCurrentCompanyOvpJobConditions(ovpJobConditions); 
                }
            },
            /**
             * Search category by name with 500ms delay.
             */
            attemptSearch() {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => this.getOvpJobConditionList(this.searchTerm), 500);
            },
        },
    }
</script>